export default {
  nav: '展位预订/展位图获取',
  step1: '选择服务类型',
  step2: '确认公司信息',
  step3: '提交服务订单',
  step4: '客户跟进对接',
  fairTime: '展会时间',
  form: {
    input: '请输入(必填)',
    scale: '请选择展位面积(必填)',
    submit: '立即提交'
  },
  tip: {
    title: '展位申请须知',
    n1: '展位咨询提交后，工作人员将在1-2个工作日内根据预留的联系方式与您进行一对一对接',
    n1_1: '展位申请提交后，工作人员将在1 - 2个工作日内根据预留的联系方式与您进行一对一对接',
    n2: '提交公司营业执照',
    n3: '提交产品图片及名称',
    n4: '接收展会介绍文件及展位图',
    n5: '提交展位申请表/签订展位合同',
    n6: '支付合同展位订金',
    t1: '沟通需求',
    i1: '参展企业预留联系方式，项目负责人跟进沟通参展企业展位需求；',
    t2: '提交审核',
    i2: '参展企业与项目负责人确认参展意向后，提交公司名称、产品名称及简介，公司官网、联系人、联系方式等，等待主办资质审核；',
    t3: '展位报价',
    i3: '项目负责人向参展企业提供展会招展函及具体展位价格；',
    t4: '展位图',
    i4_1: '1.已出图展会，提供可选展位图给参展企业选择；',
    i4_2: '2.未出图展会，需提前2-3个月支付展位订金排队等待位置分配；',
    i4_3: '3.紧俏展会，需提前至少6个月排队等待位置分配；',
    t5: '合同签订',
    i5: '参展企业与组展单位签订展位合同，一式两份盖章生效，按合同约定对公打款;',
    t6: '展位相关服务',
    i6: '展位确定后，根据时间推进依次向参展企业收取会刊信息表、展商证、展具租赁、车证等材料；',
    t7: '发票',
    i7: '展会结束后7个工作日开具正式发票；',
    t8: '评价及意见',
    i8: '展会结束后收集参展企业对展会的评价及反馈意见，改进服务；'
  }
}
